// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2dHtw","range":"MonthRangeSwitch_range__MLg00","disabled":"MonthRangeSwitch_disabled__18BNF"};